@if (statistics(); as statistics) {
	<div class="homes-statistics-tasks">
		<figure>
			<ic-donut-chart
				label="{{ completed() | number: '1.0-0' }}%"
				[values]="statistics"
				data-test="tasks-finished-percentage"
			></ic-donut-chart>
		</figure>
		<div class="homes-statistics-tasks-legend">
			@for (task of statistics; track task) {
				<ui-small-card class="lt-card-statistic {{ task.class }}" data-test="task-type-card">
					<p class="lt-card-statistic-value" data-test="task-count">{{ task.value }}</p>
					<label class="lt-card-statistic-label"> {{ task.name | translate }} </label>
					<p class="lt-card-statistic-value is-large">{{ task.percentage | number: '1.0-0' }}%</p>
				</ui-small-card>
			}
		</div>
	</div>
}
